module.exports = __webpack_public_path__ + "img/578af05bb60e98350df1ff53e1c98fcd.svg";